export default "__VITE_ASSET__DcwK2eiS__"